import React, { useEffect, useState } from "react";
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useRecoilState } from "recoil";
import { fetchCategoryList } from 'Services/inventory.services';
import { categoryAtom } from 'Recoil/inventory.atom';
import { isEmpty, isNil, map } from 'lodash';
import { encode } from 'Helpers/enc';
import { PlusOutlined, UnorderedListOutlined } from '@ant-design/icons';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { Avatar as AntAvatar, Collapse, Drawer } from 'antd';
import { generateCategoryTree } from 'Helpers/generate-categories-tree-v2';

import './mobile-category.scss';

const MobileCategory = () => {
    const history = useHistory();
    const { t } = useTranslation();
    //this refers the state of the drawer //
    const [isOpen, setIsOpen] = useState(false)
    const onClose = () => {
        setIsOpen(false);
    }

    //this refers to state of category options (lists)
    const [categoryState, setCategoryState] = useRecoilState<any>(categoryAtom);
    const [categories, setCategories] = useState<any> ([]);

    const handleFetchList = async () =>{
        setCategoryState({
            ...categoryState,
            status: { ...categoryState.status, fetch: 'loading' }
          });

        const responseData = await fetchCategoryList({
          active: true,
          level: [1, 2],
        });

        if (!isNil(responseData) && responseData.length) {
          let categories = generateCategoryTree(responseData)
          setCategories(categories)
        }
        else {
          setCategoryState({
            ...categoryState,
            status: { ...categoryState.status, fetch: 'error' }
          });
        }
    }
    useEffect(()=>{
        handleFetchList();
    },[]);

  return (
    <React.Fragment>
    {!isEmpty(categories) ?
        <div>
        <AntAvatar
          style={{ background: 'transparent' }}
          src={
            <img
              style={{ width: '62%', height: '62%' }}
              src="/assets/images/categories-icon.png"
              onClick= {()=>setIsOpen(!isOpen)}
            />
          }
        />

        {isOpen &&
          <Drawer
            className="mobile-category"
            title={t('title.categories')}
            placement="left"
            onClose={onClose}
            visible={isOpen}
          >
              <Scrollbars autoHide universal>
                {map(categories, (item, itemKey) => {
                  if (!isEmpty(item.children)) {
                    return (
                      <React.Fragment key={itemKey}>
                        <Collapse
                          ghost={true}
                          expandIconPosition="right"
                          expandIcon={({ isActive }) => <PlusOutlined rotate={isActive ? 90 : 0} />}
                        >
                          <Collapse.Panel
                            key={itemKey}
                            header={
                              <React.Fragment>
                                <span
                                  className="label"
                                  onClick={()=>history.push(`/products/catalog/list?name=${encode(item.label)}&category=${encode(item.value)}`)}
                                >
                                  {item.label}
                                </span>
                              </React.Fragment>
                            }
                          >
                            <ul>
                              {item.children.map((subItem: any, subItemKey: number | string) => {
                                return (
                                  <li key={`${itemKey}.${subItemKey}`}>
                                    <span
                                      className="label sub-label"
                                      onClick={()=>history.push(`/products/catalog/list?name=${encode(subItem.label)}&category=${encode(subItem.value)}`)}
                                    >
                                      {subItem.label}
                                    </span>
                                  </li>
                                )
                              })}
                            </ul>
                          </Collapse.Panel>
                        </Collapse>
                      </React.Fragment>
                    )
                  }
                  else {
                      return(
                        <div key={itemKey} className="no-child" style={{ padding: '7px 0' }}>
                          <span
                            className="label"
                            onClick={()=>history.push(`/products/catalog/list?name=${encode(item.label)}&category=${encode(item.value)}`)}
                          >
                            {item.label}
                          </span>
                        </div>
                      )
                  }
              })}
            </Scrollbars>
          </Drawer>
        }
      </div>
      : null
    }
    </React.Fragment>
  )
}
export default MobileCategory
